var render = function render(){var _vm=this,_c=_vm._self._c;return _c('examples-block',{attrs:{"gitUrl":"src/components/examples/Modal/CallbackCloseAndBack.vue","title":"Модальное окно с обработкой callback закрытия"}},[_c('r-button',{attrs:{"title":"Отрыть модальное окно"},on:{"click":_vm.openModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }